export enum Role {
	ADMIN = 'A',
	MEDICO = 'M',
	PACIENTE = 'P',
}
 
export enum Status {
	PENDIENTE = 'PENDIENTE',
	APROBADO = 'APROBADO',
	RECHAZADO = 'RECHAZADO',
}
 
export interface Medico {
	dni: string;
	nombre: string;
	apellido: string;
	email: string;
	telefono: string;
	password: string;
	matricula: string;
	role: Role;
	especialidades: string,
	cbu: string;
	cvBase64?: string;
	cvName?: string;
	tarifa?: number;
	status: Status, 
	loginRetries?: number,
	forgotPasswordPin?: number
	forgotPasswordExpires?: Date,
	mpToken?: boolean,
	googleToken?: boolean,
}
